import styled from 'styled-components'
import { Button } from 'components'

export const DeleteAccountActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 4.375rem;
`

export const DeleteAccountButton = styled(Button)`
  color: #3c6e90;
  font-family: Molde-regular;
  background-color: transparent;
  :hover {
    color: #b8002f;
  }
`
